export default __webpack_public_path__ + "static/media/2124.472febb9.png";